module.exports = __webpack_public_path__ + "img/stock_trade.549a39b6.jpg";